module.exports = __webpack_public_path__ + "media/images/camera-eb0dff101ce3e92f1eb2f28585d0984d.png";